import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const DaishaKbn = props => {
  return <Dropdown.Static kubunKey='daisha_kbn' {...props} />
}
